import 'consumerweb-shim';
import 'core-js/stable'; // If imports from pp-react are required, please test this component on IE
import 'regenerator-runtime/runtime';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import IntialData from '../../utility/getTemplateData';
import Footer from '../../components/footer/footer';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import { hideSpinnerOverlay } from '../../utility/helper';
import withTheme from '../../components/withTheme';
import FullPageError from './FullPageError';

import '../../../css/ppvx-app.less';
import '../../../css/ppvx.less';
import { trackErrorPageIM } from '../../fpti/fpti';
import { PAGE_SPEC } from '../../fpti/fptiConstants';

const webscrMessages = localsMessages('errors/webscr') || {};
let webscrData = templateData.webscrData || {};

function WebscrError() {
  useEffect(() => {
    const webscrErrorCode = IntialData.webscrErrorCode;
    hideSpinnerOverlay();
    trackErrorPageIM({
      pageSpec: PAGE_SPEC.WEBSCR_ERROR_PAGE,
      errorCode: webscrErrorCode,
    });
  }, []);

  const formatContent = (content, data) => {
    if (data && data.currency_code) {
      content = content.replace('{currency_code}', data.currency_code);
    }

    return content;
  };

  const webscrErrorCode = IntialData.webscrErrorCode;
  let webscrErrorMessage = webscrMessages?.webscr?.error?.[webscrErrorCode];

  if (!webscrErrorMessage) {
    webscrErrorMessage = webscrMessages?.webscr?.error?.GENERIC_ERROR;
  }
  webscrErrorMessage = formatContent(
    webscrErrorMessage,
    webscrData?.jsonParams ?? {}
  );

  return (
    <>
      <FullPageError title={webscrErrorMessage} />
      <Footer />
    </>
  );
}

const WebscrErrorWithTheme = withTheme(WebscrError);

ReactDOM.render(
  <WebscrErrorWithTheme />,
  document.getElementById('donateWrapper')
);
